import { Target, MousePointerClick, LineChart } from "lucide-react";
import Reveal from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const PROBLEMS = [
    {
        icon: Target,
        title: "Low-quality traffic",
        copy: "More clicks don't matter if the people reaching your website aren't qualified.",
        testid: "problem-card-low-quality-traffic",
    },
    {
        icon: MousePointerClick,
        title: "Poor conversion",
        copy: "A strong advertising campaign is wasted if the landing-page experience doesn't turn attention into action.",
        testid: "problem-card-poor-conversion",
    },
    {
        icon: LineChart,
        title: "No clear attribution",
        copy: "Law firms should know which campaigns and keywords are actually generating inquiries and consultations.",
        testid: "problem-card-no-clear-attribution",
    },
];

export const Problem = () => (
    <section id="problem" className="py-24 md:py-32 lg:py-40">
        <div className="shell">
            <SectionHeading
                eyebrow="The Problem"
                title="Your potential clients are already searching."
                lead="Every day, people search Google for attorneys who can help with estate planning, Medicaid planning, elder law, trusts, and other important legal needs."
            />
            <Reveal delay={0.2} className="mt-6 max-w-3xl">
                <p className="text-base lg:text-lg leading-relaxed text-zinc-400">
                    The opportunity isn't simply getting more clicks. It's
                    getting your firm in front of the right person, at the
                    right moment, and turning that search into a consultation.
                </p>
            </Reveal>
            <div className="mt-16 md:mt-20 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                {PROBLEMS.map((p, i) => (
                    <Reveal
                        key={p.title}
                        delay={0.1 + i * 0.1}
                        className="h-full"
                    >
                        <div
                            data-testid={p.testid}
                            className="h-full bg-ink-900 p-8 md:p-10 transition-colors duration-300 hover:bg-ink-hover"
                        >
                            <p.icon
                                className="h-6 w-6 text-brass-400"
                                strokeWidth={1.25}
                                aria-hidden="true"
                            />
                            <h3 className="mt-6 font-serif text-xl md:text-2xl text-white">
                                {p.title}
                            </h3>
                            <p className="mt-4 text-sm md:text-base leading-relaxed text-zinc-400">
                                {p.copy}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Problem;
